/**
 * Session Configuration
 *
 * Controls session timeout behavior and monitoring
 */

export const SESSION_CONFIG = {
  /**
   * How often to check session status (milliseconds)
   * Default: Every 60 seconds
   */
  CHECK_INTERVAL_MS: 60 * 1000,

  /**
   * Show warning when session is about to expire (minutes before expiry)
   * Default: 5 minutes before expiration
   */
  WARNING_THRESHOLD_MINUTES: 5,

  /**
   * Show critical warning (minutes before expiry)
   * Default: 1 minute before expiration
   */
  CRITICAL_THRESHOLD_MINUTES: 1,

  /**
   * Inactivity timeout (milliseconds)
   * Default: 6 hours of inactivity
   * Note: This is handled by AuthContext, not Supabase
   */
  INACTIVITY_TIMEOUT_MS: 6 * 60 * 60 * 1000,

  /**
   * Session duration for "Remember me" (seconds)
   * Default: 2 weeks (14 days)
   * Note: Supabase default is 1 hour (3600 seconds)
   */
  REMEMBER_ME_DURATION_SECONDS: 14 * 24 * 60 * 60, // 2 weeks (14 days)

  /**
   * Standard session duration (seconds)
   * Default: 6 hours
   */
  STANDARD_SESSION_DURATION_SECONDS: 6 * 60 * 60, // 6 hours
} as const;

/**
 * Get session configuration based on "Remember me" preference
 */
export function getSessionDuration(rememberMe: boolean): number {
  return rememberMe
    ? SESSION_CONFIG.REMEMBER_ME_DURATION_SECONDS
    : SESSION_CONFIG.STANDARD_SESSION_DURATION_SECONDS;
}
